module.exports = __webpack_public_path__ + "static/media/be-BY.d07dd6e0.md";